import { useState, useEffect } from 'react';
import { useHistory } from 'react-router';
import { clearSession, setSession } from '../global';
import { login } from '../services/loginservice';
import Loader from '../images/whiteloader.svg';
import { forgetPassword } from '../services/userservice';
import Logo from '../images/logo.png';
import LoginImage from '../images/login.png';

const d = {
    userId: '',
    pass: ''
}

const Login = () => {

    const history = useHistory();
    const [data, setData] = useState(d);
    const [isforget, setIsforget] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isPassword, showPassword] = useState(false);
    useEffect(() => {
        clearSession();
    }, [])

    const onSubmit = async (e) => {
        e.preventDefault();

        if (!isforget) {
            setLoading(true);
            const rs = await login(data.userId, data.pass);
            setLoading(false);
            if (rs.ok) {    
                setSession('userInfo', rs.user);
                setSession('menues', rs.menues);
                setSession('subaccounts', rs.subaccounts);
                setSession('sequences', rs.sequences);
                setSession('types', rs.types);
                setSession('services', rs.services);
                setSession('userId', data.userId);
                if(rs?.codAmountLimit) {
                    setSession('codAmountLimit', rs.codAmountLimit);
                }
                 if(rs?.codWeightLimit) {
                    setSession('codWeightLimit', rs.codWeightLimit);
                }
                if (!rs.user.isPasswordUpdated) {
                    history.push('/changepassword');
                } else {
                    const urls = rs.menues.flatMap(x => x.subMenus.map(y => y.hyperLink));
                    if (urls.includes('/'))
                        history.push('/');
                    else
                        history.push(urls[0]);
                }
                history.go();
            } else {
                alert(rs.msg);
            }
        } else {
            if (!data.email) {
                alert('Enter Email Id');
                return;
            }

            if (!data.userId) {
                alert('Enter User Id');
                return;
            }

            const z = {
                userId: data.userId,
                email: data.email,
                EncUserId: btoa(data.userId),
                EncDateTime: btoa(new Date().toJSON()),
            };
            setLoading(true);
            const rs = await forgetPassword(z);
            setLoading(false);
            alert(rs.msg);
            if (rs.ok) {
                setData(d);
            }
        }
    }

  const handlePaste = (key, val) => {
    const pastedText = val.replace(/\t/g, ""); // remove tab
    setData({ ...data, [key]: pastedText })
  };

    const updateData = (key, val) => setData({ ...data, [key]: val });

    const passwordToggle = () => {
        showPassword(!isPassword);
    };

    return <div id="app"><div className="login-page d-flex flex-wrap">
  {/* Left Section */}
  <div className="login-left d-flex flex-column align-items-center">
    <div className="text-center w-75">
      <img src={Logo} alt="M&P Logo" width={180} className="mb-3" />
      <p className="text-muted mb-4">Please sign in to access your account.</p>

      {!isforget ? (
        <form onSubmit={onSubmit}>
          <div className="mb-3 position-relative">
            <i className="fa fa-user position-absolute login-icon"></i>
            <input
              type="text"
              className="form-control ps-4"
              placeholder="username: admin or user"
              value={data.userId}
              onChange={(e) => {
                e.preventDefault();
                handlePaste('userId', e.target.value)
              }}
              autoComplete="on"
            />
          </div>

          <div className="mb-3 position-relative">
            <i className="fa fa-lock position-absolute login-icon"></i>
            <input
              type="password"
              className="form-control ps-4"
              placeholder="password: ********"
              value={data.pass}
              onChange={(e) => {
                e.preventDefault();
                handlePaste('pass', e.target.value)
              }}
//              onChange={(e) => handlePaste('pass', e.target.value)}
              autoComplete="on"
            />
          </div>

          <div className="d-flex justify-content-between align-items-center mb-3">
            {/* <div>
              <input type="checkbox" id="remember" className="me-1" />
              <label htmlFor="remember" className="small">Remember me</label>
            </div> */}
            <div></div>
            <a
              href="#"
              className="text-decoration-none small text-danger"
              onClick={(e) => {
                e.preventDefault();
                setIsforget(true);
              }}
            >
              Forgot your password?
            </a>
          </div>



          <button
            type="submit"
            disabled={!data.userId || !data.pass}
            className="btn btn-primary btn-lg w-100 py-2"
          >
            {loading ? <img src={Loader} height="25" /> : 'Sign In'}
          </button>
        </form>
      ) : (
        <form onSubmit={onSubmit}>
          <div className="mb-3 position-relative">
            <i className="fa fa-user position-absolute login-icon"></i>            
            <input
              type="text"
              className="form-control  ps-4"
              placeholder="Enter User Id"
              value={data.userId}
              onChange={(e) => {
                e.preventDefault();
                handlePaste('userId', e.target.value)
              }}
            />
          </div>

          <div className="mb-3 position-relative">
            <i className="fa fa-envelope position-absolute login-icon"></i>               
            <input
              type="text"
              className="form-control  ps-4"
              placeholder="Enter Email"
              value={data.email}
              onChange={(e) => {
                e.preventDefault();
                handlePaste('email', e.target.value)
              }}
            />
          </div>

          <a
            href="#"
            className="text-decoration-none small text-danger d-block mb-3"
            onClick={(e) => {
              e.preventDefault();
              setIsforget(false);
            }}
          >
            Back to Login
          </a>

          <button
            type="submit"
            disabled={!data.userId || !data.email}
            className="btn btn-orange w-100 py-2"
          >
            {loading ? <img src={Loader} height="30" /> : 'Send Email'}
          </button>
        </form>
      )}
    </div>
  </div>

  {/* Right Section */}
  <div className="login-right">
    <div className="overlay"></div>
    <img
      src={LoginImage} // replace with the same image shown in your screenshot
      alt="Login Banner"
      className="login-bg"
    />
  </div>
</div></div>

    // return <div id="app">
    //     <section className="section">
    //         <div className="container mt-5">
    //             <div className="row">
    //                 <div className="col-12 col-sm-8 offset-sm-2 col-md-6 offset-md-3 col-lg-6 offset-lg-3 col-xl-4 offset-xl-4">
    //                     <div className="login-brand">
    //                         <img src={Logo} alt="logo" width={200} />
    //                     </div>
    //                     {
    //                         !isforget ?
    //                             <div className="card card-primary">
    //                                 <div className="card-header"><h4>Login</h4></div>
    //                                 <form onSubmit={onSubmit}>
    //                                     <div className="card-body">
    //                                         <div className="form-group">
    //                                             <label>User Id</label>
    //                                             <input type="text" className="form-control" value={data.userId} onChange={(e) => updateData('userId', e.target.value)} autoComplete="on" />
    //                                         </div>
    //                                         <div className="form-group">
    //                                             <div className="d-block">
    //                                                 <label className="control-label">Password</label>
    //                                             </div>
    //                                             <input type="password" className="form-control" value={data.pass} onChange={(e) => updateData('pass', e.target.value)} autoComplete="on" />
    //                                         </div>
    //                                         <div className="form-group">
    //                                             <a href='#' onClick={e => {
    //                                                 e.preventDefault();
    //                                                 setIsforget(true);
    //                                             }}>Forget Password</a>
    //                                         </div>
    //                                         <div className="form-group">
    //                                             <button type="submit" disabled={!data.userId || !data.pass} className="btn btn-primary btn-lg btn-block">
    //                                                 {loading ? <img src={Loader} height="30" /> : 'Login'}
    //                                             </button>
    //                                         </div>
    //                                     </div>
    //                                 </form>
    //                             </div> :
    //                             <div className="card card-primary">
    //                                 <div className="card-header"><h4>Forget Password</h4></div>
    //                                 <form onSubmit={onSubmit}>
    //                                     <div className="card-body">
    //                                         <div className="form-group">
    //                                             <label>User Id</label>
    //                                             <input type="text" className="form-control" value={data.userId} onChange={(e) => updateData('userId', e.target.value)} />
    //                                         </div>
    //                                         <div className="form-group">
    //                                             <label className="control-label">Email</label>
    //                                             <input type="text" className="form-control" value={data.email} onChange={(e) => updateData('email', e.target.value)} />
    //                                         </div>
    //                                         <div className="form-group">
    //                                             <a href='#' onClick={e => {
    //                                                 e.preventDefault();
    //                                                 setIsforget(false);
    //                                             }}>Back To Login</a>
    //                                         </div>
    //                                         <div className="form-group">
    //                                             <button type="submit" disabled={!data.userId || !data.email} className="btn btn-primary btn-lg btn-block">
    //                                                 {loading ? <img src={Loader} height="30" /> : 'Send Email'}
    //                                             </button>
    //                                         </div>
    //                                     </div>
    //                                 </form>
    //                             </div>
    //                     }
    //                 </div>
    //             </div>
    //         </div>
    //     </section>
    // </div>
}

export default Login;